import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Badge Community Article Page
 */
const BadgeCommunity = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Badge Community</h1>
                <p className="article-subtitle">
                  Unlock exclusive benefits by connecting your Solana communities to WeSplit. Learn how to claim your special badge and double your reward points.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Overview</h2>
                  <p className="article-section-intro">
                    WeSplit has partnered with some of the most prominent communities on Solana. Members of these organizations get access to an exclusive <strong>Community Badge</strong>. Holding this badge doesn't just look good on your profile—it grants you a <strong>2x Multiplier</strong> on all points earned through our reward system.
                  </p>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">How to Claim Your Badge</h2>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Navigate to Rewards:</strong> Open the app and go to the main Rewards page.
                    </li>
                    <li>
                      <strong>Select Communities:</strong> Tap on the 'Communities' section.
                    </li>
                    <li>
                      <strong>Enter Your Code:</strong> Input the unique access code provided by your specific community (usually found in their private Discord or governance channels).
                    </li>
                    <li>
                      <strong>Claim:</strong> Tap to confirm. Your new badge is now unlocked and added to your profile inventory.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Rules & Mechanics</h2>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Point Multiplier:</strong> Active community badges double the points you generate from using the app.
                    </li>
                    <li>
                      <strong>Non-Cumulative:</strong> You can claim badges from multiple communities, but the multiplier effect does not stack. (e.g., Having two badges still grants a 2x multiplier, not 4x).
                    </li>
                    <li>
                      <strong>Display Choice:</strong> If you own multiple badges, you can choose which one appears next to your name on your public profile via the Profile Settings.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Current Partner Communities</h2>
                  <p className="article-section-intro">
                    We currently support exclusive badges for members of the following organizations:
                  </p>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>SuperteamFrance</li>
                    <li>BanditoDAO</li>
                    <li>MonkeDAO</li>
                    <li>LaFamilia</li>
                    <li>DiggersDAO</li>
                  </ul>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Your Profile',
                  route: getHelpRoute(getHelpArticleRoute('features', 'your-profile'))
                }}
                next={{
                  title: 'Send (P2P)',
                  route: getHelpRoute(getHelpArticleRoute('features', 'send-p2p'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default BadgeCommunity;
